import React, { MutableRefObject, useContext, useEffect, useRef, useState } from 'react'
import { FormDataContext } from 'app/providers/formValues/lib/FormDataContext';
import CoverageInfo from 'shared/ui/CoverageInfo/CoverageInfo';
import { SidebarUI } from './styles';
import { useMediaQuery } from '@mui/material';
import Loader from 'shared/ui/Loader/Loader';

interface Props {
	onSubmit: () => void
	loading: boolean
	refContainer?: MutableRefObject<HTMLDivElement | null>
}

export const Sidebar = ({ refContainer, onSubmit, loading }: Props) => {
	const ref = useRef<HTMLDivElement | null>(null);
	const [sticky, setSticky] = useState(false);
	const matchesSM = useMediaQuery('(max-width:900px)');
	const { isPending } = useContext(FormDataContext);

	useEffect(() => {
		const handleScroll = () => {
			if (!refContainer?.current || !ref.current) return;

			const sidebarHeight = ref.current.offsetHeight;
			const containerTop = refContainer.current.offsetTop;
			const containerHeight = refContainer.current.offsetHeight;
			const scrollY = window.scrollY;
			const topOffset = 50;

			const containerBottom = containerTop + containerHeight;

			// If container is shorter than sidebar, don't make it sticky
			if (containerHeight < sidebarHeight) {
				setSticky(false);
				return;
			}

			// Start sticking when we've scrolled past the container top
			const shouldStartSticking = scrollY > containerTop - topOffset;

			// Stop sticking when sidebar bottom would exceed container bottom
			const sidebarBottomWhenSticky = scrollY + sidebarHeight + topOffset;
			const shouldStopSticking = sidebarBottomWhenSticky > containerBottom;

			if (shouldStartSticking && !shouldStopSticking) {
				setSticky(true);
			} else {
				setSticky(false);
			}
		};

		if (!matchesSM) {
			window.addEventListener('scroll', handleScroll);
			handleScroll();
		}

		return () => {
			if (!matchesSM) {
				window.removeEventListener('scroll', handleScroll);
			}
		};
	}, [matchesSM, refContainer]);

	return (
		<SidebarUI sm={matchesSM} ref={ref} sticky={sticky}>
			{isPending && <Loader color={'rgba(255, 255, 255, 0.5)'}/>}
			<CoverageInfo onSubmit={onSubmit} loading={loading}/>
		</SidebarUI>
	)
}
